module.exports = __webpack_public_path__ + "img/star.ebcf18a5.png";